import { History } from 'history';
import {
  BaseMFEMountParams,
  BaseMFEMountResponse,
  BaseMFEProps,
  BaseMicroFrontend,
} from './BaseMicroFrontend';

export interface MicrofrontendMountParams<T> extends BaseMFEMountParams {
  onNavigate?: (params: { pathname: string }) => void;
  defaultHistory?: History;
  initialPath: string;
  basePath: string;
  params: T;
}

export interface SpecificMicroFrontendProps<T = any>
  extends Omit<MicroFrontendProps<T>, 'exposedPath' | 'name'> {}

export interface MicroFrontendProps<T = any> extends BaseMFEProps {
  history: History;
  basePath: string;
  params: T & DefaultMicroFrontendParams;
}

interface MountResponse extends BaseMFEMountResponse {
  onParentNavigate: ({ pathname }: { pathname: string }) => void;
}
interface DefaultMicroFrontendParams {
  logoutUser: () => void;
}

export class MicroFrontend<T = any> extends BaseMicroFrontend<
  MicroFrontendProps<T>
> {
  buildMountParams(): MicrofrontendMountParams<T> {
    const { history, userInfo, params, basePath } = this.props;
    return {
      initialPath: history.location.pathname,
      defaultHistory: history,
      userInfo,
      basePath,
      params,

      onNavigate: ({ pathname: nextPathname }) => {
        const { pathname } = history.location;
        if (pathname !== nextPathname) {
          history.push(nextPathname);
        }
      },
    };
  }

  afterMount({ onParentNavigate }: MountResponse): void {
    const { history } = this.props;
    history.listen(onParentNavigate);
  }
}
